/**
 * Test-only fixtures helper for LocationAutocomplete Google component.
 * Kept in a separate file so the component stays focused and test behavior
 * is isolated.
 */

export const LOCATION_AUTOCOMPLETE_FIXTURE_LABELS = ['Vienna', 'San Francisco'];

export const LOCATION_AUTOCOMPLETE_FIXTURES = [
  {
    label: 'Vienna, Austria',
    aliases: ['Wien'],
    location: { lat: 48.20849, lng: 16.37208 },
    isFixture: true,
  },
  {
    label: 'San Francisco, CA, USA',
    location: { lat: 37.7749, lng: -122.4194 },
    isFixture: true,
  },
];

export function mergeTestFixtures(mappedFixtures: any[]) {
  try {
    // Check for testing inside CI or locally
    const isTesting = process.env.PLAYWRIGHT_TESTING === 'true';
    if (!isTesting) {
      return mappedFixtures;
    }

    // Only add fixtures whose label is not already present in mappedFixtures.
    // This prevents duplicate entries when a Google API result returns the
    // same label as a fixture (e.g. after the user has already selected a
    // location and the geosuggest re-queries with the full label).
    const fixturesToAdd = LOCATION_AUTOCOMPLETE_FIXTURES.filter(
      (fixture) =>
        !mappedFixtures.some((f: any) => f && f.label === fixture.label),
    );

    return [...mappedFixtures, ...fixturesToAdd];
  } catch (e) {
    return mappedFixtures;
  }
}
